
import {
  IconChevronRight,
  RevIllustration,
  RevList,
  RevListItem,
  RevModal,
  RevSpinner,
} from '@backmarket/design-system'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { MODAL_NAMES } from '@config/constants'
import { productFrequentlyAskedQuestions } from '@http/endpoints'

import translations from './FaqModal.translations'

export default {
  components: {
    RevModal,
    RevSpinner,
    RevList,
    RevListItem,
    RevIllustration,
    IconChevronRight,
  },
  props: {
    listingId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      questions: [],
      isLoading: true,
      shouldDisplayError: false,
      cachedListingId: null,
    }
  },
  computed: {
    ...mapGetters({
      country: 'config/country',
    }),

    modalName: () => MODAL_NAMES.PRODUCT.FAQ,
    translations: () => translations,

    productId() {
      return this.$route.params.uuid
    },

    shouldRefreshQuestions() {
      const isSameQuestion = this.listingId === this.cachedListingId

      return !isSameQuestion && isEmpty(this.questions)
    },

    shouldShowQuestions() {
      return !this.isLoading && !this.shouldDisplayError
    },
  },
  methods: {
    async fetchFrequentlyAskedQuestions() {
      // if the api already returned questions in a previous open and the listingId is the same
      // no need to call the API again
      if (!this.shouldRefreshQuestions) {
        this.isLoading = false

        return
      }

      try {
        const { payload } = await this.$store.dispatch('http/request', {
          request: productFrequentlyAskedQuestions,
          pathParams: { id: this.productId, listingId: this.listingId },
        })

        this.questions = payload.questions
        this.cachedListingId = this.listingId
        this.isLoading = false
      } catch {
        this.isLoading = false
        this.shouldDisplayError = true
      }
    },

    resetLoading() {
      this.isLoading = true
    },
  },
}
